import initialState from "./state";
import CRUD_ACTION_TYPES, { getNamedAction } from "actions/CRUD_ACTION_TYPES";
import ACTION_NAMES from "actions/ACTION_NAMES";

function workflowsReducer(state = initialState, { type, ...action }) {
    switch (type) {
        case getNamedAction(ACTION_NAMES.SKIP_CALLBACKS, CRUD_ACTION_TYPES.UPDATE_REQUEST):
            return { ...state, isSkipingCallback: true };
        case getNamedAction(ACTION_NAMES.SKIP_CALLBACKS, CRUD_ACTION_TYPES.UPDATE_SUCCESS):
            return { ...state, isSkipingCallback: false };
        case getNamedAction(ACTION_NAMES.SKIP_CALLBACKS, CRUD_ACTION_TYPES.UPDATE_FAILURE):
            return { ...state, isSkipingCallback: false };
        default:
            return state;
    }
}

export default workflowsReducer;
